export default __webpack_public_path__ + "images/45_2_image.jpg";